import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface Props extends InputHTMLAttributes<HTMLInputElement> { label?: string; hint?: string; error?: string }
export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { className, label, hint, error, id, ...rest }, ref) {
  const aid = id || rest.name;
  return (
    <label className="block">
      {label ? <span className="block t-cap mb-1.5">{label}</span> : null}
      <input ref={ref} id={aid}
        className={cn('w-full h-11 px-3.5 rounded-md bg-paper-elev ring-1 ring-paper-edge text-ink-1 text-[15px] placeholder:text-ink-3 focus:ring-terre focus:outline-none', error && 'ring-danger', className)}
        {...rest} />
      {hint && !error && <span className="block t-ui-xs text-ink-3 mt-1">{hint}</span>}
      {error ? <span className="block t-ui-xs text-danger mt-1">{error}</span> : null}
    </label>
  );
});
